import { createQuestionSchemaWithMixins } from '../questionSchemaFields';
import { config } from './MediaFileText.config';

export const schema = createQuestionSchemaWithMixins({
  mixins: {},
  type: config.name,
});
